exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader[data-v-4add6303]{text-align:center;color:#bbb}", ""]);

// exports
